// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Box, Input, Button, Text, VStack, HStack } from "@chakra-ui/react";
// import { FiClipboard, FiCheck } from 'react-icons/fi';

// const ChatComponent = () => {
//   const initialPrompt = "You are a cybersecurity expert that is helping CISO's and other security team members in an organization estimate or quantify cyber risk. The goal for you is to guide the user through a series of questions and answers about a specific asset within a business unit such that the user will end up with a formula that allows them to estimate a $ value for that asset in terms of cyber risk. Note that this $ value will then be entered in a system that allows the user to rank assets by cyber risk and prioritize these assets for vulnerability patching accordingly. Do not overwhelm the user, just ask them one question at a time.";
//   const initialMessage = { role: "user", text: initialPrompt };
//   const [history, setHistory] = useState([initialMessage]);
//   const [input, setInput] = useState('');
//   const [messages, setMessages] = useState([initialMessage]);
//   const [copiedMessageIndex, setCopiedMessageIndex] = useState(null);

//   const sendMessage = async (message) => {
//     if (!message.trim()) return; // Avoid sending empty messages
  
//     const newMessage = { role: 'user', text: message };
//     const updatedHistory = [...history, newMessage];
//     setHistory(updatedHistory);
//     setMessages([...messages, newMessage]); // Optimistically update UI
  
//     try {
//       const api_url = `${process.env.REACT_APP_AWS_FLASK_BASE_URI}/use_openai`;
//       const headers = { 'Content-Type': 'application/json' };
//       const data = {
//         api_key: process.env.REACT_APP_AWS_FLASK_API_KEY,
//         history: updatedHistory.map(msg => ({ role: msg.role, text: msg.text })),
//         question: message,
//       };
  
//       console.log('Sending request to API:', api_url);
//       console.log('Request payload:', data);
  
//       const response = await axios.post(api_url, data, { headers });
//       console.log('API Response:', response);
  
//       if (response.status === 200) {
//         const botMessage = { role: 'model', text: response.data.text };
//         setMessages(prevMessages => [...prevMessages, botMessage]);
//         setHistory(prevHistory => [...prevHistory, botMessage]);
//       } else {
//         console.error(`Failed to get a response: ${response.status} - ${response.statusText}`);
//       }
//     } catch (error) {
//       console.error('Error sending message:', error.message);
//     } finally {
//       setInput(''); // Clear the input box
//     }
//   };
  
//   const handleSubmit = (event) => {
//     event.preventDefault();
//     sendMessage(input);
//   };

//   const copyToClipboard = (text, index) => {
//     navigator.clipboard.writeText(text).then(() => {
//       setCopiedMessageIndex(index);
//       setTimeout(() => setCopiedMessageIndex(null), 2000); // Reset after 2 seconds
//     }).catch(err => {
//       console.error('Failed to copy: ', err);
//     });
//   };

//   useEffect(() => {
//     const fetchInitialMessage = async () => {
//       const api_url = `${process.env.REACT_APP_AWS_FLASK_BASE_URI}/use_openai`;
//       const headers = { 'Content-Type': 'application/json' };
//       const data = {
//         api_key: process.env.REACT_APP_AWS_FLASK_API_KEY,
//         history: history,
//         question: initialPrompt,
//       };

//       try {
//         console.log('Initial request payload:', data);

//         const response = await axios.post(api_url, data, { headers });
//         if (response.status === 200) {
//           const botMessage = { role: 'model', text: response.data.text };
//           setMessages(prevMessages => [...prevMessages, botMessage]);
//           setHistory(prevHistory => [...prevHistory, botMessage]);
//         } else {
//           console.error(`Failed to get a response: ${response.status} - ${response.statusText}`);
//         }
//       } catch (error) {
//         console.error(`Error: ${error.message}`);
//       }
//     };

//     fetchInitialMessage();
//   }, []);

//   return (
//     <Box p={5} w="100%" mx="auto" mt={10} bg="white" borderRadius="lg" boxShadow="lg">
//       <Text fontSize="2xl" fontWeight="bold" mb={5}>Chat with AIVRM</Text>
//       <VStack
//         spacing={4}
//         align="stretch"
//         h="400px"
//         overflowY="auto"
//         border="1px solid"
//         borderColor="gray.200"
//         p={4}
//         borderRadius="lg"
//         mb={4}
//       >
//         {messages.map((msg, index) => (
//           <Box key={index} alignSelf={msg.role === 'user' ? 'flex-end' : 'flex-start'}>
//             <Text fontWeight="bold" color={msg.role === 'user' ? 'blue.500' : 'green.500'}>
//               {msg.role === 'user' ? 'You: ' : 'AIVRM: '}
//             </Text>
//             <Text whiteSpace="pre-wrap">{msg.text}</Text>
//             {msg.role === 'model' && (
//               <Button
//                 onClick={() => copyToClipboard(msg.text, index)}
//                 size="xs"
//                 leftIcon={copiedMessageIndex === index ? <FiCheck /> : <FiClipboard />}
//               >
//                 {copiedMessageIndex === index ? 'Copied' : 'Copy'}
//               </Button>
//             )}
//           </Box>
//         ))}
//       </VStack>
//       <HStack as="form" onSubmit={handleSubmit}>
//         <Input
//           type="text"
//           value={input}
//           onChange={(e) => setInput(e.target.value)}
//           placeholder="Type your message here..."
//         />
//         <Button onClick={handleSubmit} colorScheme="teal" type="submit">Send</Button>
//       </HStack>
//     </Box>
//   );
// };

// export default ChatComponent;

// ChatComponent.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Input, Button, Text, VStack, HStack } from "@chakra-ui/react";
import { FiClipboard, FiCheck } from 'react-icons/fi';

const ChatComponent = () => {
  const initialPrompt = "You are a cybersecurity expert that is helping CISO's and other security team members in an organization estimate or quantify cyber risk. The goal for you is to guide the user through a series of questions and answers about a specific asset within a business unit such that the user will end up with a formula that allows them to estimate a $ value for that asset in terms of cyber risk. Note that this $ value will then be entered in a system that allows the user to rank assets by cyber risk and prioritize these assets for vulnerability patching accordingly. Do not overwhelm the user, just ask them one question at a time."
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([{ role: "system", content: initialPrompt }]);
  const [copiedMessageIndex, setCopiedMessageIndex] = useState(null);

  const sendMessage = async (message) => {
    if (!message.trim()) return;

    const newMessage = { role: 'user', content: message };
    setMessages([...messages, newMessage]);

    try {
      const response = await axios.post(`${process.env.REACT_APP_AIVRM_BACKEND_OPENAI_URI}/api/chat_with_openai`, { messages }); // localhost:3000 works

      if (response.status === 200) {
        const botMessage = { role: 'system', content: response.data.content };
        setMessages([...messages, newMessage, botMessage]);
      }
    } catch (error) {
      console.error('Error:', error.message);
    } finally {
      setInput('');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendMessage(input);
  };

  const copyToClipboard = (text, index) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedMessageIndex(index);
      setTimeout(() => setCopiedMessageIndex(null), 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  return (
    <Box p={5} w="100%" mx="auto" mt={10} bg="white" borderRadius="lg" boxShadow="lg">
      <Text fontSize="2xl" fontWeight="bold" mb={5}>Chat with AIVRM</Text>
      <VStack
        spacing={4}
        align="stretch"
        h="400px"
        overflowY="auto"
        border="1px solid"
        borderColor="gray.200"
        p={4}
        borderRadius="lg"
        mb={4}
      >
        {messages.map((msg, index) => (
          <Box key={index} alignSelf={msg.role === 'user' ? 'flex-end' : 'flex-start'}>
            <Text fontWeight="bold" color={msg.role === 'user' ? 'blue.500' : 'green.500'}>
              {msg.role === 'user' ? 'You: ' : 'AIVRM: '}
            </Text>
            <Text whiteSpace="pre-wrap">{msg.content}</Text>
            {msg.role === 'system' && (
              <Button
                onClick={() => copyToClipboard(msg.content, index)}
                size="xs"
                leftIcon={copiedMessageIndex === index ? <FiCheck /> : <FiClipboard />}
              >
                {copiedMessageIndex === index ? 'Copied' : 'Copy'}
              </Button>
            )}
          </Box>
        ))}
      </VStack>
      <HStack as="form" onSubmit={handleSubmit}>
        <Input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message here..."
        />
        <Button onClick={handleSubmit} colorScheme="teal" type="submit">Send</Button>
      </HStack>
    </Box>
  );
};

export default ChatComponent;
